import { theme } from '../../theme';

interface SkullLogoProps {
  size?: number;
  className?: string;
}

/**
 * Simplified Spartan skull helmet — matches the flat illustration style.
 * Uses only brand colors: charcoal helmet, cream skull, copper accents, burgundy shadows.
 */
export const SkullLogo = ({ size = 40, className }: SkullLogoProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Helmet crest (copper) */}
    <path
      d="M42 8 L50 2 L58 8 L58 30 L42 30 Z"
      fill={theme.brand.copper}
    />
    {/* Helmet body (charcoal) */}
    <path
      d="M22 35 C22 18, 78 18, 78 35 L78 55 C78 58, 75 60, 72 60 L28 60 C25 60, 22 58, 22 55 Z"
      fill={theme.brand.charcoal}
    />
    {/* Skull face (cream) */}
    <path
      d="M28 38 C28 28, 72 28, 72 38 L72 65 C72 78, 60 88, 50 92 C40 88, 28 78, 28 65 Z"
      fill={theme.brand.cream}
    />
    {/* Left eye socket (burgundy) */}
    <ellipse cx="38" cy="50" rx="7" ry="8" fill={theme.brand.burgundy} />
    {/* Right eye socket (burgundy) */}
    <ellipse cx="62" cy="50" rx="7" ry="8" fill={theme.brand.burgundy} />
    {/* Nose (burgundy) */}
    <path d="M47 62 L50 68 L53 62 Z" fill={theme.brand.burgundy} />
    {/* Jaw line / teeth (burgundy stripes) */}
    <rect x="38" y="74" width="3" height="8" fill={theme.brand.burgundy} />
    <rect x="44" y="74" width="3" height="8" fill={theme.brand.burgundy} />
    <rect x="50" y="74" width="3" height="8" fill={theme.brand.burgundy} />
    <rect x="56" y="74" width="3" height="8" fill={theme.brand.burgundy} />
    {/* Helmet side flaps (copper) */}
    <path d="M22 40 L18 55 L22 60 L28 55 Z" fill={theme.brand.copper} />
    <path d="M78 40 L82 55 L78 60 L72 55 Z" fill={theme.brand.copper} />
  </svg>
);

export default SkullLogo;
